import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export const useDeleteInternalAuditResultsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.internalAuditResult.delete.mutationOptions({
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.internalAuditResult.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.assessment.internalAuditResultCount.queryKey(),
          }),
        ]);
      },
    }),
  });

  return {
    deleteInternalAuditResults: async (ids: string[]): Promise<void> => {
      await mutation.mutateAsync({ Ids: ids });
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
